import * as Sentry from '@sentry/browser'

if (
  typeof SENTRY_DSN !== 'undefined' &&
  SENTRY_DSN &&
  !window.__sentryInitialized__
) {
  window.__sentryInitialized__ = true

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: RAILS_ENV,
    tracesSampleRate: 0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
      Sentry.replayIntegration(),
    ],

    debug: false,
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 0.05,
    ignoreErrors: [
      "Network Error",
      "Can't find variable: _AutofillCallbackHandler",
      "Loading chunk 996 failed", // erro integração do chat com zendesk
      "RA-Reputation: bad response from server https://api.reclameaqui.com.br/embed-reputation/", // erro integração reclame aqui
      "Java exception was raised during method invocation",
      "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
      "Java object is gone",
      "The operation is insecure",
      "window.webkit.messageHandlers",
      "Error invoking postMessage:",
      "[NavigationTypeDetection]",
      "Error invoking enableDidUserTypeOnKeyboardLogging:",
      "Cannot access 'Ws' before initialization",
      "Cannot access 'js' before initialization",
      "Load failed",
      "Failed to fetch",
    ]
  })

}

window.notificarSentry = (error) => {
  if (!window.__sentryInitialized__) return

  Sentry.captureException(error)
}
